<template>
  <div class="forgot grid h100" v-loading="loading">


  <div class="" v-if="valid && !loading">

    <h3>Prego inserisci la tua nuova password</h3>

    <div class="spacer sm"></div>
    
    <el-form :model="formel" :rules="rules" ref="formLogin" @keyup.enter.native="forgot('formLogin')" status-icon>
        <el-form-item prop="password" label="nuova password">
            <el-input v-model="formel.password" show-password placeholder="Password" name="password"></el-input>
          </el-form-item>
        <div class="spacer xs"></div>
        <!-- <el-form-item>
          <el-button class="btn green block" @click="forgot('formLogin')">cambia password</el-button>
        </el-form-item> -->
        <button class="btn green block" @click="forgot('formLogin')">cambia password</button>
      </el-form>

  </div>

  <div v-else>
    <h3>Link non valido</h3>
  </div>

  </div>
</template>

<script>
var host = process.env.VUE_APP_API
import router from './../router'
export default {
  name: 'Forgotpassword',
  data () {
    return {
      loading: false,
      valid: true,
      formel: {
        email: '',
        password: ''
      },
      rules: {
        password: [
            { required: true, message: 'prego inserisci una password', trigger: 'blur' },
            { min: 8, message: 'lunghezza minima 8 caratteri', trigger: 'blur' }
        ]
      },
      error: {
        state: false,
        message: ''
      },
      success: {
        state: false,
        message: ''
      }
    }
  },
  methods: {
    forgot (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('login')
          this.loading = true
          setTimeout(() => {
            this.loading = false
          }, 2000)
          this.error.state = false
          this.$http
            .post(host + '/resetpassword', {email: this.formel.email.toLowerCase().trim(), password: this.formel.password, token: this.$route.params.token},
            ).then(() => {
              router.replace('/')
              this.loading = false
            }, (error) => {
              console.log(error)
              // this.loading = false
              setTimeout(() => {
                this.loading = false
              }, 1000)
              this.error.state = true
              this.error.message = error.body.error
            })
        } else {
          console.log('error submit!!')
          // return false
        }
      })
    },
    getHotel () {
      this.$http
        .post(host + '/checkreset', { token: this.$route.params.token }
        ).then((data) => {
          console.log(data)
          this.formel.email = data.body.email
          this.valid = true
          this.loading = false
        }, (error) => {
          console.log(error)
          // router.replace('/')
          this.valid = false
          this.loading = false
          this.error.state = true
          this.error.message = error.body.error
        })
    }
  },
  beforeMount () {
    this.getHotel()
  },
  mounted: function () {
    // this.$refs.emailinput.focus()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
